import type { JSX } from 'react';
import { EducationItem } from './EducationItem';
import type { Education } from '../types/education.types';

export interface EducationCardsProps {
  educations: Education[];
  onEdit: (education: Education) => void;
  onDelete: (educationId: string) => void;
}

/** The already filtered/sorted education records, as cards. */
export function EducationCards({ educations, onEdit, onDelete }: EducationCardsProps): JSX.Element {
  if (educations.length === 0) {
    return (
      <p className="text-sm text-muted-foreground py-6 text-center">
        No education records match the current filters.
      </p>
    );
  }

  return (
    <div className="space-y-3">
      {educations.map((education) => (
        <EducationItem
          key={education.id}
          education={education}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
